import Config from "services/config/config";
import callWebService, {
  callTypes
} from "services/utils/networks/network";
import {
  TICKET_LISTING
} from "./type";

export const getTicketsList = (filterData = null, page = 1) => async (dispatch) => {
  try {
    dispatch({
      type: TICKET_LISTING,
      payload: null,
    });

    const apiUrl = filterData === null 
      ? `${Config.tickets.getTicketsList}?page=${page}`
      : `${Config.tickets.getTicketsList}?page=${page}${filterData.ticketId ? `&ticket_id=${filterData.ticketId}` : ""}${filterData.status ? `&status=${filterData.status}` : ""}`

    const res = await callWebService(
      callTypes.get,
      "",
      apiUrl
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: TICKET_LISTING,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: TICKET_LISTING,
      payload: null,
    });
  }
};